import styled, { css } from "styled-components";
import {
  Dialog as MuiDialog,
  DialogContent as MuiDialogContent,
  IconButton
} from "@material-ui/core";

export const Dialog = styled(MuiDialog)`
	.MuiPaper-root {
		background: ${props => props.theme.palette.primary.main};
		box-shadow: none;
		width: ${props => props.theme.widthRatio*478}px;
		max-width: unset;
		padding: ${props => props.theme.widthRatio*33}px
		         ${props => props.theme.widthRatio*24}px;
		align-items: center;
		border-radius: 10px;
		position: relative;
		margin-left: ${props => props.theme.widthRatio * 280}px;
		
    ${props => props.theme.name === 'dark' && css`
      border: 1px solid ${props => props.theme.palette.secondary.main};
    `}
  
    ${props => props.theme.name === 'light' && css`
      box-shadow: 0 2px 32px 4px rgba(0,0,0,0.2);
    `}
    
    .MuiDialogContent-root {
      height: 100%;
      
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
	
	.MuiBackdrop-root {
	  background-color: rgba(0,0,0,0) !important;
	}
`;

export const DialogContent = styled(MuiDialogContent)`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	padding: 0 !important;
	color: ${props => props.theme.palette.third[100]};
	text-align: center;
	
	h4 {
		font: ${props => props.theme.widthRatio*30}px/${props => props.theme.heightRatio*40}px SFProRounded-Bold;
		margin: 0 0 ${props => props.theme.widthRatio*25}px;
	}
	
	p {
	  font: ${props => props.theme.widthRatio * 21}px/${props => props.theme.heightRatio * 28}px SFProRounded-Regular;
	  margin: 0 ${props => props.theme.widthRatio*20}px;
	  text-align: center;
	  
	  &.footer-text {
	    color: #A5A5A5;
	    margin: ${props => props.theme.heightRatio*30}px 0 0;
	    font: ${props => props.theme.widthRatio * 18}px/${props => props.theme.heightRatio * 24}px SFProRounded-Regular;
	  }
	}
	
	a {
    margin: 0;
    color: ${props => props.theme.palette.secondary.main};
    
    ${props => props.theme.name === 'dark' && css`
      &.dark-light {
        color: white;
        text-decoration: none;
      }
    `}
  }
  
  .divider {
    width: 100%;
    margin: ${props => props.theme.heightRatio*25}px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    .line {
      width: 100%;
      border: 1px solid #A5A5A5;
    }
    
    p {
      color: #A5A5A5;
      margin: 0 ${props => props.theme.widthRatio*13}px;
  }
`;

export const CloseButton = styled(IconButton)`
  padding: 0;
  width: ${props => props.theme.widthRatio * 40}px;
  height: ${props => props.theme.widthRatio * 40}px;
  position: absolute;
  right: ${props => props.theme.widthRatio * 10}px;
  top: ${props => props.theme.widthRatio * 15}px;
  cursor: pointer;
  font: ${props => props.theme.widthRatio*26}px/${props => props.theme.heightRatio*35}px SFProRounded-Bold;
  color: ${props => props.theme.palette.third[100]};
`;
